// src/actions/course_resources_actions.js
import * as API from "../util/course_resources_api_util";

// =====================
// Constants
// =====================
export const COURSE_RESOURCES_LOADING = "COURSE_RESOURCES_LOADING";
export const RECEIVE_COURSE_RESOURCES = "RECEIVE_COURSE_RESOURCES";
export const RECEIVE_COURSE_RESOURCE = "RECEIVE_COURSE_RESOURCE";
export const REMOVE_COURSE_RESOURCE = "REMOVE_COURSE_RESOURCE";
export const COURSE_RESOURCES_ERROR = "COURSE_RESOURCES_ERROR";

// =====================
// Action Creators
// =====================
export const courseResourcesLoading = (isLoading) => ({
  type: COURSE_RESOURCES_LOADING,
  isLoading,
});

export const receiveCourseResources = (resources, courseKey) => ({
  type: RECEIVE_COURSE_RESOURCES,
  resources,
  courseKey
});

export const receiveCourseResource = (resource) => ({
  type: RECEIVE_COURSE_RESOURCE,
  resource,
});

export const removeCourseResource = (id) => ({
  type: REMOVE_COURSE_RESOURCE,
  id,
});

export const courseResourcesError = (error) => ({
  type: COURSE_RESOURCES_ERROR,
  error,
});

// =====================
// Thunks
// =====================
export const fetchCourseResources =
  ({ courseKey, includeInactive = false } = {}) =>
  async (dispatch) => {
    dispatch(courseResourcesLoading(true));
    dispatch(courseResourcesError(""));
    try {
      const res = await API.fetchCourseResources({ courseKey, includeInactive });
      dispatch(receiveCourseResources(res.data.resources || [], courseKey)); // ✅ include courseKey
    } catch (e) {
      dispatch(courseResourcesError(e?.response?.data?.error || "Failed to load resources."));
    } finally {
      dispatch(courseResourcesLoading(false));
    }
  };

export const createCourseResource = (formData) => async (dispatch) => {
  dispatch(courseResourcesLoading(true));
  dispatch(courseResourcesError(""));
  try {
    const res = await API.createCourseResource(formData);
    dispatch(receiveCourseResource(res.data.resource));
    return res.data.resource;
  } catch (e) {
    dispatch(courseResourcesError(e?.response?.data?.error || "Failed to create resource."));
    throw e;
  } finally {
    dispatch(courseResourcesLoading(false));
  }
};

export const updateCourseResource = (id, formData) => async (dispatch) => {
  dispatch(courseResourcesLoading(true));
  dispatch(courseResourcesError(""));
  try {
    const res = await API.updateCourseResource(id, formData);
    dispatch(receiveCourseResource(res.data.resource));
    return res.data.resource;
  } catch (e) {
    dispatch(courseResourcesError(e?.response?.data?.error || "Failed to update resource."));
    throw e;
  } finally {
    dispatch(courseResourcesLoading(false));
  }
};

export const deleteCourseResource = (id) => async (dispatch) => {
  dispatch(courseResourcesLoading(true));
  dispatch(courseResourcesError(""));
  try {
    await API.deleteCourseResource(id);
    dispatch(removeCourseResource(id));
  } catch (e) {
    dispatch(courseResourcesError(e?.response?.data?.error || "Failed to delete resource."));
    throw e;
  } finally {
    dispatch(courseResourcesLoading(false));
  }
};
